import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo buscando ejercicios que nunca quedan bien', 'Clases improvisadas sin guion ni progresión', 'Alumnos que abandonan a los 2 meses', 'Evaluaciones inventadas sin criterios', 'Horas perdidas que nunca se recuperan'];
  return <section className="py-6 md:py-10 px-4 bg-brand-card border-y border-white/5" data-id="element-150">
      <div className="max-w-2xl mx-auto" data-id="element-151">
        <h2 className="text-lg md:text-2xl font-black text-center mb-4 text-white leading-tight" data-id="element-152">
          Si sos entrenador funcional, esto te va a sonar familiar:
        </h2>

        <div className="bg-brand-dark border-l-4 border-brand-accent p-4 rounded-r-xl mb-4" data-id="element-153">
          <div className="space-y-2" data-id="element-154">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-155">
                <XCircle className="w-4 h-4 text-red-500 mr-2 shrink-0 mt-0.5" data-id="element-156" />
                <p className="text-xs md:text-sm text-gray-300 font-medium leading-snug" data-id="element-157">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-2" data-id="element-158">
          <h3 className="text-base md:text-xl font-black text-brand-accent neon-glow leading-tight" data-id="element-159">
            ¿Cuántos fines de semana más vas a perder?
          </h3>
          <p className="text-xs text-gray-400 font-medium" data-id="element-160">
            Da igual si estás en Buenos Aires, CDMX, Bogotá, Santiago o Lima. El
            problema es el mismo.{' '}
            <span className="text-white font-bold" data-id="element-161">La solución también.</span>
          </p>
        </div>
      </div>
    </section>;
}